// angled buttons
const redzoneButtons = document.querySelectorAll(
  ".is-style-bar, section.products > h2"
);
redzoneButtons.forEach(function (elem) {
  let html =
    elem.innerHTML +
    '<span class="bar"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="87" height="5" viewBox="0 0 87 5"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#parmDots" x="0" y="0"></use></svg></span>';
  elem.innerHTML = html;
});
